import React from 'react';

import Icon from '../Icon/Icon';

const AgeGateTickBlueIcon = (props) => {
    return (
        <Icon width='64' height='64' {...props}>
            <g fill='none' fillRule='evenodd'>
                <circle fill='#00D1D2' cx='42.795' cy='41.91' r='9' />
                <path
                    stroke='#34303D'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='m38.295 42.878 2.545 2.664 6.455-6.632'
                />
                <path
                    d='M31.111 48.218h-18.7a4.385 4.385 0 0 1-3.12-1.292A4.38 4.38 0 0 1 8 43.808v-6.067c0-1.853.722-3.597 2.033-4.908 1.368-1.368 2.896-2.034 4.671-2.034h15.22c1.702 0 3.171.61 4.492 1.86a1.245 1.245 0 1 1-1.713 1.808c-.86-.812-1.716-1.175-2.778-1.175h-15.22c-1.111 0-2.008.403-2.91 1.305a4.414 4.414 0 0 0-1.303 3.144v6.067c0 .513.199.992.561 1.355.363.362.845.562 1.357.562h18.701a1.246 1.246 0 0 1 0 2.493M24.224 10.49c-4.562 0-8.274 3.713-8.274 8.276 0 4.559 3.712 8.273 8.274 8.273 4.561 0 8.273-3.714 8.273-8.273 0-4.563-3.712-8.277-8.273-8.277zm0 19.038c-5.936 0-10.765-4.829-10.765-10.762C13.459 12.829 18.288 8 24.224 8c5.936 0 10.765 4.829 10.765 10.766 0 5.933-4.83 10.762-10.765 10.762z'
                    fill='#272830'
                />
                <path
                    d='M24.18 25.006a6.484 6.484 0 0 1-5.928-3.864.842.842 0 0 1 .432-1.112.842.842 0 0 1 1.112.43 4.794 4.794 0 0 0 4.385 2.858 4.814 4.814 0 0 0 4.485-3.105.844.844 0 0 1 1.58.596 6.51 6.51 0 0 1-6.065 4.197'
                    fill='#00D1D2'
                />
                <path
                    d='M42.803 30.743c-6.158 0-11.167 5.008-11.167 11.168 0 6.157 5.01 11.165 11.167 11.165S53.97 48.068 53.97 41.911c0-6.16-5.01-11.168-11.167-11.168zm0 24.363c-7.277 0-13.198-5.92-13.198-13.195 0-7.278 5.92-13.198 13.198-13.198C50.08 28.713 56 34.633 56 41.91c0 7.275-5.92 13.195-13.197 13.195z'
                    fill='#272830'
                />
            </g>
        </Icon>
    );
};

export default AgeGateTickBlueIcon;
